import { MessageStatus, MessageType } from "../enums/traffic-info-enums";

export interface TimeInterval {
  timeIntervalStart: string;
  timeIntervalEnd: string;
}

export class MessageOverview {
  constructor(
    public id: string,
    public messageStatus: MessageStatus,
    public from: Date,
    public to: Date | null,
    public heading: string,
    public location: string,
    public affected: string,
    public createdOrUpdatedBy: string,
    public lastUpdatedAt: Date,
    public messageType: MessageType,
    public timeInterval: TimeInterval | null = null
  ) {}
}